/**
 * wkData.js — WK League (South Korea Women's Football)
 * 2025 season — 8 teams. Hwacheon KSPO champions (beat Seoul Amazones in final).
 */

export const WK_SEASON     = '2025';
export const WK_WORKER_URL = 'https://wk-proxy.footballgirl.workers.dev';

export const WK_STANDINGS_FALLBACK = [
  { pos:1, name:'Hwacheon KSPO WFC',          short:'HWA', color:'#0033A0', zone:'champion', p:19, w:10, d:8, l:1,  gf:37, ga:16, gd:21,  pts:38, form:['W','W','D','D','W'] },
  { pos:2, name:'Gyeongju Korea H&N WFC',     short:'GYE', color:'#004B87', zone:'top',      p:18, w:10, d:3, l:5,  gf:38, ga:23, gd:15,  pts:33, form:['W','L','W','D','W'] },
  { pos:3, name:'Seoul Amazones',             short:'SEO', color:'#C8102E', zone:'top',      p:18, w:8,  d:9, l:1,  gf:33, ga:18, gd:15,  pts:33, form:['D','W','W','D','W'] },
  { pos:4, name:'Incheon Hyundai Steel R.A.', short:'INC', color:'#E60026', zone:'n',        p:17, w:7,  d:7, l:3,  gf:19, ga:16, gd:3,   pts:28, form:['D','W','D','L','W'] },
  { pos:5, name:'Sejong Sportstoto WFC',      short:'SEJ', color:'#FF6600', zone:'n',        p:18, w:5,  d:6, l:7,  gf:15, ga:18, gd:-3,  pts:21, form:['L','D','W','L','D'] },
  { pos:6, name:'Suwon FC Women',             short:'SUW', color:'#003DA5', zone:'n',        p:19, w:4,  d:7, l:8,  gf:20, ga:29, gd:-9,  pts:19, form:['D','L','D','W','L'] },
  { pos:7, name:'Mungyeong Sangmu WFC',       short:'MUN', color:'#006B3F', zone:'n',        p:17, w:4,  d:5, l:8,  gf:19, ga:26, gd:-7,  pts:17, form:['L','D','L','W','L'] },
  { pos:8, name:'Changnyeong FC Women',       short:'CHA', color:'#8B0000', zone:'n',        p:18, w:1,  d:1, l:16, gf:12, ga:47, gd:-35, pts:4,  form:['L','L','L','L','L'] },
];

export const WK_TOP_SCORERS_FALLBACK = [
  { initials:'KM', name:'Kim Min-jung',      club:'Incheon Hyundai Steel', goals:14 },
  { initials:'CS', name:'Choe Yu-ri',        club:'Hwacheon KSPO',         goals:11 },
  { initials:'LY', name:'Lee Young-ju',      club:'Seoul Amazones',        goals:9  },
  { initials:'JH', name:'Ji So-yun',         club:'Suwon FC Women',        goals:7  },
  { initials:'PH', name:'Park Eun-seon',     club:'Gyeongju Korea H&N',    goals:6  },
  { initials:'SJ', name:'Son Hwa-yeon',      club:'Sejong Sportstoto',      goals:5  },
];

export const WK_FIXTURES_FALLBACK = [
  { date:'2025-06-05', home:'Sejong Sportstoto',  homeColor:'#FF6600', homeGoals:0, awayGoals:0, away:'Hwacheon KSPO',       awayColor:'#0033A0', status:'FT' },
  { date:'2025-06-05', home:'Suwon FC Women',     homeColor:'#003DA5', homeGoals:2, awayGoals:2, away:'Hyundai Steel R.A.',  awayColor:'#E60026', status:'FT' },
  { date:'2025-06-05', home:'Changnyeong FC',     homeColor:'#8B0000', homeGoals:0, awayGoals:0, away:'Seoul Amazones',      awayColor:'#C8102E', status:'FT' },
  { date:'2025-06-14', home:'Hwacheon KSPO',      homeColor:'#0033A0', homeGoals:null, awayGoals:null, away:'Changnyeong FC',      awayColor:'#8B0000', status:'NS' },
  { date:'2025-06-14', home:'Hyundai Steel R.A.', homeColor:'#E60026', homeGoals:null, awayGoals:null, away:'Mungyeong Sangmu',    awayColor:'#006B3F', status:'NS' },
];

export async function fetchLiveWKData() {
  if (!WK_WORKER_URL || WK_WORKER_URL.includes('footballgirl')) {
    console.info('[WK] PROXY_URL not set — using fallback data.');
    return null;
  }
  try {
    const r = await fetch(WK_WORKER_URL, { signal: AbortSignal.timeout(6000) });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const d = await r.json();
    return {
      standings:  d.standings  ?? WK_STANDINGS_FALLBACK,
      topScorers: d.topScorers ?? WK_TOP_SCORERS_FALLBACK,
      fixtures:   d.fixtures   ?? WK_FIXTURES_FALLBACK,
    };
  } catch (e) {
    console.warn('[WK] Live fetch failed, using fallback:', e.message);
    return null;
  }
}
